module.exports = {
	"ha": "vcha",
	"id": 5.7,
	"report": {
		"ha": "Vancouver Coastal Health",
		"group": "HSDA",
		"period": "2017 Q2–2018 Q1",
		"lastYear": "2018",
		"lastQuarter": "1"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 950,
			"height": 530,
			"marginTop": 60,
			"marginLeft": 100,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "column"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1,
			"valueSuffix": " %"
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 80px;\">Figure 5.7</span>                 <span style=\"display: table-cell;\">Estimated Cascade of Care for Vancouver Coastal Health by HSDA, Year Ending 2018 Q1 <sup style=\"font-size: 10px;\">9</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {},
					"verticalAlign": "top"
				},
				"pointPadding": 0,
				"groupPadding": 0,
				"stacking": "normal",
				"colorByPoint": true
			},
			"column": {
				"colors": [
					"",
					"#043f61",
					"#0c4250",
					"#0d4440",
					"#09472e",
					"#0a4a23"
				]
			}
		},
		"xAxis": [
			{
				"lineWidth": 0,
				"tickWidth": 0,
				"labels": {
					"reserveSpace": false,
					"rotation": 270,
					"y": -80,
					"align": "left",
					"style": {
						"fontSize": "1.2em",
						"color": "white",
						"textOutline": "0.5px contrast"
					}
				},
				"categories": [
					"",
					"Linked to Care",
					"Retained in Care",
					"On Treatment",
					"Adherent",
					"Suppressed",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					""
				]
			}
		],
		"yAxis": [
			{
				"height": "83%",
				"max": 100,
				"tickPosition": "inside",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#231f20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"title": {
					"text": "% of Diagnosed",
					"margin": -10,
					"x": -30
				},
				"labels": {
					"format": "{value}%"
				},
				"plotLines": [
					{
						"value": 0,
						"color": "black",
						"dashStyle": "solid",
						"width": 1,
						"zIndex": 100
					}
				]
			},
			{
				"top": "83%",
				"height": "17%",
				"tickPosition": "inside",
				"lineColor": "#9e1c20",
				"lineWidth": 1,
				"tickColor": "#9e1c20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#9e1c20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"max": 0,
				"min": -20,
				"title": {
					"text": "% Loss from<br>Previous Stage",
					"margin": -10,
					"style": {
						"color": "#9e1c20"
					},
					"x": -30
				},
				"labels": {
					"format": "{value}%",
					"style": {
						"color": "#9e1c20"
					},
					"zIndex": 1
				}
			}
		],
		"series": [
			{
				"name": "% of Diagnosed",
				"yAxis": 0,
				"data": [
					{
						"y": null
					},
					{
						"y": 97.16981132075472,
						"dataLabels": {
							"enabled": true,
							"format": "309"
						}
					},
					{
						"y": 91.50943396226415,
						"dataLabels": {
							"enabled": true,
							"format": "291"
						}
					},
					{
						"y": 87.10691823899371,
						"dataLabels": {
							"enabled": true,
							"format": "277"
						}
					},
					{
						"y": 83.64779874213836,
						"dataLabels": {
							"enabled": true,
							"format": "266"
						}
					},
					{
						"y": 72.0125786163522,
						"dataLabels": {
							"enabled": true,
							"format": "229"
						}
					},
					{
						"y": null
					},
					{
						"y": 93.7888198757764,
						"dataLabels": {
							"enabled": true,
							"format": "151"
						}
					},
					{
						"y": 83.22981366459628,
						"dataLabels": {
							"enabled": true,
							"format": "134"
						}
					},
					{
						"y": 81.36645962732919,
						"dataLabels": {
							"enabled": true,
							"format": "131"
						}
					},
					{
						"y": 78.26086956521739,
						"dataLabels": {
							"enabled": true,
							"format": "126"
						}
					},
					{
						"y": 68.32298136645963,
						"dataLabels": {
							"enabled": true,
							"format": "110"
						}
					},
					{
						"y": null
					},
					{
						"y": 97.09750566893423,
						"dataLabels": {
							"enabled": true,
							"format": "4282"
						}
					},
					{
						"y": 84.73922902494331,
						"dataLabels": {
							"enabled": true,
							"format": "3737"
						}
					},
					{
						"y": 81.0204081632653,
						"dataLabels": {
							"enabled": true,
							"format": "3573"
						}
					},
					{
						"y": 75.32879818594105,
						"dataLabels": {
							"enabled": true,
							"format": "3322"
						}
					},
					{
						"y": 65.94104308390023,
						"dataLabels": {
							"enabled": true,
							"format": "2908"
						}
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "% Loss from Previous Stage",
				"yAxis": 1,
				"data": [
					{
						"y": null
					},
					{
						"y": -2.8301886792452824,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -5.825242718446599,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -4.810996563573888,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -3.971119133574008,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -13.909774436090228,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -6.211180124223603,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -11.258278145695366,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -2.238805970149249,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -3.8167938931297662,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -12.698412698412698,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -2.9024943310657636,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -12.727697337692668,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -4.388546962804385,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -7.024909040022386,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -12.462372065021077,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			}
		],
		"groups": [
			{
				"x": 3,
				"text": "North Shore/Coast Garibaldi<br>n=318"
			},
			{
				"x": 9,
				"text": "Richmond<br>n=161"
			},
			{
				"x": 15,
				"text": "Vancouver<br>n=4410"
			}
		],
		"dataTable": {
			"North Shore / Coast Garibaldi": [
				318,
				309,
				291,
				277,
				266,
				229
			],
			"Richmond": [
				161,
				151,
				134,
				131,
				126,
				110
			],
			"Vancouver": [
				4410,
				4282,
				3737,
				3573,
				3322,
				2908
			]
		}
	},
	"callback": "C:\\Users\\Rafael\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_vcha_5_7.png"
};


//////////////////
// WEBPACK FOOTER
// ./temp/json/figure_vcha_5_7.json
// module id = 302
// module chunks = 0